<template>
  <div>
    <h3 class="related-posts--title">{{ $t("generals.related") }}</h3>
    <div :class="['related-posts']" v-if="slides.length > 0">
      <arrow-slider class="related-posts__arrow-slider" @click="nextSlide" />
      <slick ref="slick" :options="slickOptions" class="related-posts__slider">
        <grid-item
          v-for="(slide, index) in slides"
          :key="`${slide.title}-${index}`"
          :image="slide.image"
          :title="slide.title"
          :client="slide.client"
          :year="slide.year"
          :country="slide.regional_name"
          theme="default"
          :link="`/works/${$i18n.locale}/${slide.slug}`"
        />
      </slick>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import ArrowSlider from "@/assets/arrow-slider.svg";

export default {
  name: "related-posts",

  components: {
    Slick,
    "arrow-slider": ArrowSlider,
  },

  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      copySlides: [],
      slickOptions: {
        slidesToShow: 2,
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 900,
        cssEase: "cubic-bezier(.15,.22,.6,.9)",
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      },
    };
  },

  watch: {
    slides() {
      if (this.$refs.slick) {
        this.$refs.slick.destroy();
        this.$nextTick(() => {
          this.$refs.slick.create();
          this.$refs.slick.setOption(this.slickOptions);
          this.$refs.slick.setPosition();
        });
      }
    },
  },

  methods: {
    nextSlide() {
      this.$refs.slick.next();
    },
  },
};
</script>

<style lang="scss">
.related-posts {
  height: auto;
  width: 95%;
  left: 9%;
  padding: 0;
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 30px 15px;

  &--title {
    width: 95%;
    left: 8.4%;
    position: relative;
    padding-left: 25px;
    font-size: 28px;
    font-weight: 300;
    margin-bottom: 15px;
    font-family: $david;
  }

  &__slider {
    display: flex;
    position: relative;

    &__item {
      height: 40vw;
      background-size: cover !important;
    }
  }

  .slick-track {
    display: flex;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider {
    display: flex;
    overflow: hidden;
    width: 100%;
    justify-content: flex-end;
  }

  .slick-list {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-perspective: 1000px;
    perspective: 1000px;
  }

  .slick-slide {
    margin-left: 15px;
    width: 30vw !important;
    overflow: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    transition: opacity 0.3s ease-out;
  }

  &__arrow-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -90px;
    margin: auto;
    width: 80px;
    height: 80px;
    cursor: pointer;
    transition: all 0.3s ease-out;
    opacity: 1;

    image {
      width: 80px;
      height: 80px;
    }

    &:hover {
      opacity: 0.5;
      transition: opacity 0.3s ease-in-out;
    }
  }
}

@media (max-width: 1300px) {
  .related-posts {
    &__arrow-slider {
      left: -70px;
      width: 60px;
      height: 60px;

      image {
        width: 60px;
        height: 60px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .related-posts {
    padding: 20px;

    &--title {
      width: 95%;
      left: 9%;
      position: relative;
      padding-left: 18px;
      font-size: 23px;
      font-weight: 300;
      margin-bottom: 15px;
    }

    &__two-items {
      .row {
        padding: 0 !important;

        .column {
          padding: 0 !important;
          margin-bottom: 20px !important;
          width: 100% !important;
        }
      }
    }

    .slick-slide {
      width: 85vw !important;
    }

    &__arrow-slider {
      width: 40px;
      height: 40px;
      left: -30px;

      image {
        width: 40px;
        height: 40px;
      }
    }
  }
}

@media (max-width: 400px) {
  .related-posts {
    padding: 20px;

    &__arrow-slider {
      width: 30px;
      height: 30px;
      left: -25px;
      transition: opacity 0.3s ease-in-out;
      opacity: 1;

      image {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
